import {isEmptyObj} from "lib@/util";

/**
 * 当前管理用户的类
 */
class User {
    constructor() {
        this._userData                = null;
        this._lang                = null;
        this._flatPermissionList      = {};
        this._localStorageUserDataKey = 'admin_user_data_json';
        this._localStorageLangKey = 'admin_lang';
    }

    get pureUserToken() {
        let token = this.getUserData('token', '');
        token = token.replace(/Bearer /,'');
        return token;
    }

    get userToken() {
        return this.getUserData('token', '');
    }

    set userToken(token) {
        let userData = this.getUserData();
        userData.token = token;
        this.saveUserData(userData);
    }

    saveUserData(userData) {
        this._userData = userData;
        localStorage.removeItem(this._localStorageUserDataKey);
        localStorage.setItem(
            this._localStorageUserDataKey,
            JSON.stringify(userData),
        );
        return true;
    }

    clearUserData() {
        this._flatPermissionList = {};
        return this.saveUserData({});
    }

    getUserData(dataKey = '', defaultData = '') {
        if (!this._userData) {
            let jsonData = localStorage.getItem(this._localStorageUserDataKey) || '';
            this._userData = jsonData ? JSON.parse(jsonData) : {};
        }

        if (dataKey == '') {
            return this._userData;
        }

        return this._userData[dataKey] || defaultData;
    }

    getDefaultRoute() {
        let pageList = this.getUserData('page_list', []);
        let permission = this._getFirstPermission(pageList);
        return permission.route || '';
    }

    getFlatPermissionList() {
        if(!isEmptyObj(this._flatPermissionList)){
            return this._flatPermissionList;
        }

        let pageStack = [];
        let pageList = [];

        pageStack.push(this.getUserData('page_list', []));

        while(pageList = pageStack.pop()){
            for(const page of pageList){
                this._flatPermissionList[page.item.id] = page.item;

                if(page.children.length > 0){
                    pageStack.push(page.children);
                }
            }
        }

        return this._flatPermissionList;
    }

    getCheckoutPermission(permission=''){
        if(permission != ''){
            let permission_list = this.getUserData('permission_list'); 
            if(permission_list.length >0){
                return permission_list.find(item => {
                    return item  ==  permission
                })  !== undefined;
            }
            return false;
        }
        
        return false;
    }

    _getFirstPermission(pageList) {
        if (pageList.length < 1) {
            return {};
        }

        for (let k in pageList) {
            let treeNode = pageList[k];

            if (treeNode.item.type == 2) {
                return treeNode.item;
            }

            let tmp = this._getFirstPermission(treeNode.children || []);

            if (!isEmptyObj(tmp)) {
                return tmp;
            }
        }

        return {};
    }

    saveUserLang(lang) {
        this._lang = lang;
        localStorage.removeItem(this._localStorageLangKey);
        localStorage.setItem(
            this._localStorageLangKey,
            lang,
        );
        return true;
    }

    getUserLang(){
        return localStorage.getItem(this._localStorageLangKey) || 'en-us';
    }
}

export default new User();